export type AssistancePortalRuntimeConfig = {
  apiUrl: string;
  auth0: {
    domain: string;
    clientId: string;
    audience: string;
  };
  environment: string;
  useDevAuth: boolean | string;
};

declare global {
  interface Window {
    assistancePortal?: AssistancePortalRuntimeConfig;
  }
}

export var assistancePortalConfig: AssistancePortalRuntimeConfig = {
  apiUrl: 'VUE_APP_API_URL',
  auth0: {
    domain: 'VUE_APP_AUTH0_DOMAIN',
    clientId: 'VUE_APP_AUTH0_CLIENT_ID',
    audience: 'VUE_APP_AUTH0_AUDIENCE',
  },
  environment: 'VUE_APP_ENVIRONMENT',
  useDevAuth: 'VUE_APP_USE_DEV_AUTH',
}

export function initAssistancePortalConfig() {
  var useDevAuth = String(assistancePortalConfig.useDevAuth) === 'true'
  window.assistancePortal = {
    ...assistancePortalConfig,
    useDevAuth,
  }
  assistancePortalConfig.useDevAuth = useDevAuth
  return window.assistancePortal
}

export function getApiUrl() {
  return window.assistancePortal?.apiUrl ?? assistancePortalConfig.apiUrl
}

export function useDevAuthEnabled() {
  return window.assistancePortal?.useDevAuth === true
}

export function isAuth0Configured() {
  var domain = assistancePortalConfig.auth0.domain
  var clientId = assistancePortalConfig.auth0.clientId
  if (!domain || !clientId) {
    return false
  }
  if (domain.startsWith('VUE_APP_') || clientId.startsWith('VUE_APP_')) {
    return false
  }
  return true
}
